import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = false
window.Stimulus = application

// Import all controllers
import AutoSaveController from "./auto_save_controller"
import DismissibleAlertController from "./dismissible_alert_controller"
import DropdownController from "./dropdown_controller"
import GalleryController from "./gallery_controller"
import ImageSliderController from "./image_slider_controller"
import ImageUploadController from "./image_upload_controller"
import LightboxController from "./lightbox_controller"
import MessagesController from "./messages_controller"
import ModalController from "./modal_controller"
import ModalBackdropController from "./modal_backdrop_controller"
import PostFormController from "./post_form_controller"
import QuickPostController from "./quick_post_controller"
import ReactionController from "./reaction_controller"
import SearchExpandController from "./search_expand_controller"
import UnsavedChangesController from "./unsaved_changes_controller"

// Register controllers
application.register("auto-save", AutoSaveController)
application.register("dismissible-alert", DismissibleAlertController)
application.register("dropdown", DropdownController)
application.register("gallery", GalleryController)
application.register("image-slider", ImageSliderController)
application.register("image-upload", ImageUploadController)
application.register("lightbox", LightboxController)
application.register("messages", MessagesController)
application.register("modal", ModalController)
application.register("modal-backdrop", ModalBackdropController)
application.register("post-form", PostFormController)
application.register("quick-post", QuickPostController)
application.register("reaction", ReactionController)
application.register("search-expand", SearchExpandController)
application.register("unsaved-changes", UnsavedChangesController)

export { application }
